import React from 'react'
import { Page, Navbar, Block } from 'framework7-react'

export default () => (
  <Page>
    <Navbar title="Under Development" backLink="Back" />
      <Block 
        style={{
          background: "#fed448",
          background: "-webkit-linear-gradient(155deg, #fed447, hsla(46, 99%, 45%, 1))",
          background: "linear-gradient(155deg, #fed447, hsla(46, 99%, 45%, 1))",

          margin: 0,
          height: "calc(100vh - 38px)"
      }}>
        <div id="spin-container">
          <div id="shape-404">
            <div id="shard-inner">
              <h1 
                style={{
                  fontSize: "80px",
                  margin: 0,
                  fontWeight: "bolder",
                  lineHeight: "70px",
                  color: "#4E342E",
                  textShadow: "0px 1px 1px hsl(13, 26%, 36%), 0px -1px 1px hsla(11, 26%, 10%, 1)",
              }}>
                &#9888;
              </h1>
              <p style={{color: "#3E2723"}}>
                Sorry the link is under development!
              </p>
            </div>
          </div> 
        </div>

        <span id="shard1" className="shards-404"></span>
        <span id="shard2" className="shards-404"></span>
        <span id="shard3" className="shards-404"></span>
      </Block>
  </Page>
)
